

import useTranslations from "../providers/useTranslations";
import { formatPrice } from "../lib/utils";

import Product from './order/product'

const ProductView = (props) => {

  const { addItemToCart, optionsFirst,
    categories,
    isOffer,
    removeItem,
    setItemQuantity,
    selectedMenu,
    product,
    setSelectedProduct } = props;

  //const { tr /* , getTranslations, locale, translations, setLocale */ } = useTranslations();

 React.useEffect(() => {


  }, [product]);


  const titleElement = () => {

    let fsize = Math.max(10, Math.min(40, 40 - (product.name.length - 4)))

    //console.log("ProductView titleElement product name", product.name, product.name.length, fsize)

    return (
      <div className="titleElement mt-3 py-2 col-md-12">

          <span className="category-expander" onClick={() => setSelectedProduct(null)} style={{
            marginRight: 5,fontSize: fsize
          }}>
            <i className="fa fa-chevron-left fa-2x" aria-hidden="true" style={{ color: '#222' }}></i>
          </span>

          <span style={{
            fontSize: fsize
          }}>
            {product.name} <br />

          </span>

        </div>
    )
  }


  //console.log("category", category.name, category.Categories, category.Products)

  return (<div id={`product_${product.name}`} className="ProductView row px-1" >

    {titleElement()}


    <div className ="col-md-12" style={{
      padding: 4
    }}>

      <div id={`product_content_${product.id}`}
        className="product-content mb-1">


        <ProductDetails
          categories={categories}
          product={product}
          hasOrdering={true}
          priceUnit='$'
          isOffer={isOffer}
          getValue={(args) => {
            console.log("getValue add to cart", product.id, args);
            if (args.quantity === 1) {
              // make a copy of the object
              let newItem = Object.assign({}, product);
              newItem.quantity = 1
              newItem.menu_id = product.menu_id || selectedMenu.id
              addItemToCart(newItem, args);
            } else if (args.quantity === 0) {
              removeItem(product, args);
            } else {
              setItemQuantity(product, args.quantity);
            }

          }}
          onClose={() => {
            setSelectedProduct(null)
          }}
          detailColour={'#F1AD3E'}
          optionsFirst={optionsFirst}
        />

      </div>

    </div>

  </div>)
}

export default ProductView

function ProductDetails(props) {
  const { product, hasOrdering, onClose, isOffer, categories, detailColour, optionsFirst } = props

  /*
  id={product.id}

          image={product.photo}
          title={product.name}
          price={product.price}

  */
  const [displayPrice, setDisplayPrice] =React.useState(product.price)
  const [numItems, setNumItems] =React.useState(1)

  const { tr /* , getTranslations, locale, translations, setLocale */ } = useTranslations();

  const IncrementItem = () => {
    setNumItems(numItems + 1);
  }
  const DecreaseItem = () => {
    //setQuantity(quantity - 1 );
    if (numItems > 1) {
      setNumItems(numItems - 1);
    }
  }

  const getDisplayedBasePrice = () => {
    // if this is a combo product and the price is 0 then display a message
    if (isOffer) {
      return tr("Only available in the XooNoo mobile app")
    }
    if (displayPrice == 0) {
      return tr("Price may vary")
    }
    //return `${props.priceUnit}${displayPrice}`
    return formatPrice(displayPrice)
  }

  const _productSize = (product) => {
    if (product.chosenSize) return (<span>({product.chosenSize})</span>)
    else if (product.size) return (<span>({product.size})</span>)
    return <></>
  }

  const _totalPrice = () => {
    if (displayPrice == 0) {
      return <></>
    }
    return <span>Total: <b>{formatPrice(numItems * displayPrice)}</b></span>

  }

  //console.log("display price", displayPrice, product.price, numItems)

  const totalHeader = () => {
    return <div className="ProductView-total-header" style={{ padding: 0, minWidth: "145px" }}>
      <div className="my-1 product-displayed-base-price">@ {getDisplayedBasePrice()}</div>
      <div className="justify-content-center" style={{ marginLeft: -5, marginTop: "5px", marginBottom: "5px", minWidth: "120px" }}>
        <span className="" style={{   }}>
          <button variant="" onClick={DecreaseItem} className="btn-count"> <i className="icofont-minus" /> </button>
          <input className="count-number-input count-number" type="text" value={numItems} readOnly />
          <button variant="" onClick={IncrementItem} className="btn-count"> <i className="icofont icofont-plus" /> </button>
        </span>
        <span className=" product-total" style={{ padding: 0, paddingTop: "6px", fontSize: "15px" }}>
          {_totalPrice()} {_productSize(product)}
        </span>
      </div>
    </div>
  }

  const carouselHeader = (assets) => {
    const options = {
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 1,
        },
        1000: {
          items: 2,
        },
        1200: {
          items: 3,
        },
      },
      items: assets.length,
      lazyLoad: true,
      pagination: "false",
      loop: true,
      center: true,
      dots: true,
      loop: true,
      margin: 10,
      autoplay: true,
      autoplayTimeout: 3000,
      autoplayHoverPause: true,
      nav: false,
      navText: ["<i class='icofont-thin-left'></i>", "<i class='icofont-thin-right'></i>"]
    }
    return (
      <div className="row product-header carousel-product-header business-assets-carousel">
        <div className="col-12 centered">
          <div className="owl-carousel owl-theme owl-carousel-five offers-interested-carousel">
            {assets.map((a, index) => {
              return (
                <div className="item" key={`carouselImg_${index}`}>
                  <img src={a.url} style={{
                    maxHeight: 200,
                    minHeight: 200,
                    maxWidth: 600,
                  }} />
                </div>
              )
            })

            }

          </div>
        </div>
        {totalHeader()}
      </div>
    )

  }

  const assetHeader = (url) => {
    return <div className='row product-header asset-product-header centered' >
      <img onClick={onClose}

      /* className="col-10 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-8" */ src={url} alt={props.imageAlt}
        style={{
          borderRadius: "8px", marginRight: "5px", padding: 0, marginBottom: "5px",
          maxHeight: 200,
          minHeight: 200,
          minWidth: 330,
          maxWidth: 600,
        }}
      />
      {totalHeader()}

    </div>
  }

  const imageHeader = (image) => {
    return <div>

      <div className=' product-header image-product-header centered' >
        {image ?
          <div onClick={() => {
            onClose()
          }}


          >  <img className={props.imageClass} src={image} alt={props.imageAlt}
          style={{ borderRadius: 5, width: "60%" }} />
          </div>
          :
          <div onClick={() => {
            onClose()
          }} className="mr-3"><i className={"icofont-ui-press text-" + props.badgeVariant + " food-item"} /></div>
        }


      </div>
      <div>

        {totalHeader()}
      </div>
    </div>

  }

  const productHeader = () => {
    if (product.Assets != null && product.Assets.length > 0) {
      // if only 1 asset use that as an image
      if (product.Assets.length == 1) {
        return assetHeader(product.Assets[0].url)

      }

      // otherwise create a carousel with the images
      return carouselHeader(product.Assets)
    }

    return imageHeader(product.photo)
  }

  return (
    <div className={"p-4  QuickBite " + props.itemClass}>


      <div>
        {productHeader()}

        <Product product={product}
          categories={categories}
          value={numItems}
          isOffer={isOffer}
          onClose={onClose}
          detailColour={detailColour}
          setDisplayTotal={(price, prod) => {
            setDisplayPrice(price)
          }}
          formatPrice={formatPrice}
          getDisplayedBasePrice={getDisplayedBasePrice}
          increment={IncrementItem}
          decrement={DecreaseItem}
          hasOrdering={hasOrdering} optionsFirst={optionsFirst} />

      </div>

    </div>
  );
}